<template>
  <v-dialog v-model="dialog" persistent max-width="500">
    <template v-slot:activator="{ on, attrs }">
      <div class="d-flex justify-center">
        <v-btn
          v-bind="attrs"
          v-on="on"
          class="text-body-1 text-none text-uppercase font-weight-medium"
          color="grey lighten-2"
          depressed
          outlined
          block
          large
          tile
        >
          <div class="primary--text text--lighten-1">Buscar Terrenos</div>
          <v-icon color="primary lighten-1" size="16" right> fa-search </v-icon>
        </v-btn>
      </div>
    </template>

    <v-card class="pa-4">
      <v-btn
        @click="dialog = false"
        class="search-close-button"
        color="primary"
        depressed
        x-small
        fab
      >
        <v-icon color="white"> fa-times </v-icon>
      </v-btn>

      <TitleWidget small>Buscar Terrenos</TitleWidget>

      <TerrainSearchBasicForm
        class="mt-4"
        v-on:search-submit="dialog = false"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import TerrainSearchBasicForm from "../forms/TerrainSearchBasicForm.vue";

const _data = {
  dialog: false,
};

export default {
  data: () => ({
    ..._data,
  }),
  components: {
    TitleWidget,
    TerrainSearchBasicForm,
  },
};
</script>

<style lang="scss" scoped>
.search-close-button {
  position: absolute;
  right: 16px;
  top: 5px;
}
</style>
